"use client";

import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "./theme-provider";
import { useLocale } from "@/components/locale/locale-provider";

export function ThemeToggle({
  className,
}: {
  className?: string;
}) {
  const { theme, toggle } = useTheme();
  const { t } = useLocale();
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={toggle}
      aria-label={theme === "dark" ? t("enableLightMode") : t("enableDarkMode")}
      title={theme === "dark" ? t("lightMode") : t("darkMode")}
      className={className}
    >
      {theme === "dark" ? <Sun /> : <Moon />}
    </Button>
  );
}
